"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const generateUniqueString_1 = __importDefault(require("../utils/generateUniqueString"));
const MissingEntityError_1 = __importDefault(require("./MissingEntityError"));
const ids = [];
class Schema {
    constructor(collectionId, relations) {
        this.callId = '';
        this.collectionId = collectionId;
        this.relations = relations;
        this.unfold = this.unfold.bind(this);
    }
    getCollectionId() {
        return this.collectionId;
    }
    shouldClear(db, shouldClear, callId = (0, generateUniqueString_1.default)()) {
        if (this.callId === callId)
            return db.getCollection(this.collectionId) != this.previousCallCollection;
        this.callId = callId;
        return (db.getCollection(this.collectionId) != this.previousCallCollection ||
            Object.values(this.relations).reduce((changed, schemaId) => {
                return changed || shouldClear(db, schemaId, callId);
            }, false));
    }
    setPreviousCallCollection(db) {
        this.previousCallCollection = db.getCollection(this.collectionId);
    }
    fold(entity, db, run) {
        if (!entity)
            return;
        const folded = db.getItem(this.getCollectionId(), entity.id);
        if (folded != null)
            return folded;
        const replacedItems = { ...entity };
        for (const key of Object.keys(this.relations)) {
            if (entity[key] == null)
                continue;
            replacedItems[key] = this.relations[key](run, db, entity[key]) ?? entity[key];
        }
        db.addItem(this.getCollectionId(), replacedItems);
        return replacedItems;
    }
    unfold(id, db, run, options) {
        let entity;
        if (typeof id === 'object') {
            entity = id;
            if (!entity)
                return id;
        }
        else {
            if (!id || !db.getCollection(this.collectionId))
                return id;
            entity = db.getItem(this.collectionId, id);
            if (!entity)
                throw new MissingEntityError_1.default(id, this.collectionId);
        }
        const replacedItems = Object.assign({}, entity);
        this.setPreviousCallCollection(db);
        const virtuals = [];
        for (var key in this.relations) {
            if (this.relations.hasOwnProperty(key)) {
                if (entity[key] == null) {
                    if (this.relations[key].get) {
                        virtuals.push({ key, fn: this.relations[key].get });
                    }
                    continue;
                }
                if (typeof this.relations[key] == 'function') {
                    replacedItems[key] = this.relations[key](run, db, entity[key], options);
                    replacedItems[key] = replacedItems[key] ? replacedItems[key] : entity[key];
                }
            }
        }
        if (options.virtuals) {
            for (const v of virtuals) {
                replacedItems[v.key] = v.fn.call(replacedItems, db.collections);
            }
        }
        return replacedItems;
    }
}
exports.default = Schema;
